/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Logout_PendingInputs */

const de_auth_logout_pending = /** @type {(inputs: Auth_Logout_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie werden abgemeldet…`)
};

/** @type {(inputs: Auth_Logout_PendingInputs) => LocalizedString} */
const en_auth_logout_pending = de_auth_logout_pending;

/**

* @param {Auth_Logout_PendingInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_logout_pending = /** @type {((inputs?: Auth_Logout_PendingInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Logout_PendingInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_logout_pending(inputs)
	return en_auth_logout_pending(inputs)
});